import React, { Component } from 'react'
import GoogleTagManager from 'gtm'

import MenuOffCanvas from 'components/MenuOffCanvas'
import Header from 'components/Header'
import Footer from 'components/Footer'
import ReportTableSubheader from 'components/ReportTableSubheader'

import SelectedRegionController from 'modules/Controllers/SelectedRegion/SelectedRegionController'
import SurveyControllerContainer from 'modules/Controllers/Survey/SurveyControllerContainer'
import HTMLTitleController from 'modules/Controllers/HTMLTitle/HTMLTitleController'
import ReportTableContainer from 'modules/Content/ReportTableContainer'

class ReportTablePage extends Component {
  
  componentDidMount() {
    // let url = this.props.history.location.pathname;
  }

  render() {
    return (
      <div className="App">
        <GoogleTagManager gtmId="GTM-NXH8F9G" />
        <SelectedRegionController />
        <SurveyControllerContainer />
        <MenuOffCanvas />
        <Header />
        <ReportTableSubheader />
        <ReportTableContainer/>
        <Footer />
        <HTMLTitleController />
      </div>
    )
  }
}

export default ReportTablePage



// WEBPACK FOOTER //
// ./src/pages/ReportTablePage/ReportTablePage.jsx